import React from 'react';
import { useListContext } from 'react-admin';
import { TablePagination } from './table-pagination';

export const ReactAdminPagination: React.FC = () => {
  const { page, perPage, total, setPage, setPerPage, isLoading } = useListContext();
  
  if (!total) return null;
  
  const totalPages = Math.ceil(total / perPage);
  
  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePerPageChange = (newPerPage: number) => {
    setPerPage(newPerPage);
    setPage(1); // Reset to first page when changing page size
  };

  return (
    <TablePagination
      currentPage={page}
      totalPages={totalPages}
      perPage={perPage}
      total={total}
      onPageChange={handlePageChange}
      onPerPageChange={handlePerPageChange}
      disabled={isLoading}
    />
  );
};